class SliderBrand extends HTMLElement
{
    swiper_comment;
    swiper_brand;

    connectedCallback()
    {
        this.swiper_brand = new Swiper('.slider-brand-thumb', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            watchSlidesProgress: true,
        })

        this.swiper_comment = new Swiper('.slider-brand-comment', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            thumbs: {
                swiper: this.swiper_brand,
                slideThumbActiveClass: 'active'
            }
        })
    }

    disconnectedCallback()
    {}
}

customElements.define('slider-brand', SliderBrand)